<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card title="Görsel Yükle">
          <pre-loading v-if="uploading" />
          <template v-else>
            <!-- Eğer Görsel mevcutsa resmi görüntülemek için b-img kullanıyoruz -->
            <b-img
              v-if="itemData.image"
              :src="baseURL + '/media/about/' + itemData.image"
              alt="Görsel"
              fluid
              class="mb-3"
            />
            <b-form-file
              id="image-file"
              v-model="image"
              class="mt-1"
              placeholder="Bir dosya seçin veya buraya bırakın..."
              drop-placeholder="Dosyayı buraya bırakın..."
              browse-text="Dosya Seçin"
            />
            <div class="mt-1">
              <b-button
                variant="primary"
                :disabled="!image"
                @click="uploadFile"
              >
                <FeatherIcon icon="UploadIcon" />
                Görsel Yükle
              </b-button>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BRow, BFormFile, BImg,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'ImageCardFile',
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
    BFormFile,
    BImg,
    PreLoading,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      image: null,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
    uploading() {
      return this.$store.getters['fileUpload/uploading']
    },
  },
  methods: {
    uploadFile() {
      const formData = new FormData()
      formData.append('file', this.image)
      console.log(this.image)
      this.$store.dispatch('fileUpload/uploadFile', {
        upload_file: this.image,
        folder: 'about',
      })
        .then(response => {
          this.itemData.image = response.filename
        })
        .catch(error => {
          console.error('Dosya yükleme hatası:', error)
        })
    },
  },
}
</script>
